<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <div class="mb-3">
      <md-card class="card" style="margin: 1.5rem;">
        <md-card-content>
          <md-layout md-gutter>
            <!-- <md-layout md-flex="10"> -->
              <!-- <md-button
                @click="goBack"
                class="md-raised md-primary md-button-color md-theme-default back heght-1px"
              >&laquo; Back</md-button>-->
            <!-- </md-layout> -->
            <!-- <md-layout md-flex="35"></md-layout> -->
            <md-layout class="justify-content-center">
              <h2>E-Mail Content</h2>
            </md-layout>
          </md-layout>
          <hr class="hr-s">
          <b-row>
            <b-col md="4">
              <label for="event">Event Name</label>

              <b-form-input :formatter="capitalizeAll" name="event" id="event" v-model="emailModal.event"></b-form-input>
              <span class="error" v-if="!emailModal.event">{{errorSend.event}}</span>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="11">
              <label>Email Content</label>
              <quill-editor
                style="width:100% !important;height:300px !important;background:#fff;display:inline-block"
                v-model="emailModal.description"
              ></quill-editor>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col md="11" style="text-align:center;">
              <md-button
                style="margin-top:18px"
                @click="sendMail"
                id="sendLoaderMain"
                class="md-raised md-primary md-button-color md-theme-default back heght-1px"
              >{{emailModal.contentId==''?'Add':'Edit'}}</md-button>
              <md-spinner md-indeterminate id="sendLoader" style="display:none"></md-spinner>
            </b-col>
          </b-row>
          <md-layout md-gutter>
            <!-- <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="35">
              <label>Add Cc.(if Any)</label>
              <b-form-input :formatter="capitalizeAll" name="mailCC" id="mailCC" v-model="emailModal.mailCC"></b-form-input>
            </md-layout>-->
            
          </md-layout>
          <hr class="hr-border" v-if="emailBody.length>0">
          <div class="box" v-if="emailBody.length>0">
            <div class="box-header text-center">
              <h2>Mail Content Details</h2>
            </div>

            <div class="table-responsive tableMain">
              <table id="truckDetail2" class="table">
                <thead>
                  <tr>
                    <th>Sr No.</th>
                    <th>Event</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item,index) in emailBody"
                    :key="index"
                    @click="editMail(item)"
                    class="pointer"
                  >
                    <td>{{index+1}}</td>
                    <td>{{item.event}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-confirm>
  </div>
</template>


<script>
import Vue from "vue";
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../../helper/filters";
import { globalPermissionStatus } from "../../../helper/collection";

export default {
  beforeMount() {
    if (globalPermissionStatus("Main Master")) {
      this.$store.dispatch("setCurrentRoute", "/mailMaster/addMailContent");
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }
  },
  data() {
    return {
      alert: {
        content:
          this.$sessionsStorage.get("editDriverId") != "" &&
          this.$sessionsStorage.get("editDriverId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok"
      },
      permissionStatus:
        this.$sessionsStorage.get("PermissionStatus") !== undefined &&
        this.$sessionsStorage.get("PermissionStatus") == "Read"
          ? true
          : false,

      arrayerrorSend: ["Select Activity "],
      errorSend: {
        event: ""
      },
      AllDetails: {},
      showMailDetails: [],
      isLoading: false,
      emailBody: [],
      validateTrans: true,
      emailModal: {
        contentId: "",
        event: "",
        description: "",
        subject: ""
      }
    };
  },
  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading
    CustomLoader,
  },
  computed: {},
  watch: {},
  methods: {
    editMail(item) {
      Object.keys(this.emailModal).map(x => {
        this.emailModal[x] = item[x] || "";
      });
      window.scroll(0, 100);
    },
    goBack() {
      this.$router.push({
        path: "/vehicle/vehicleBooking"
      });
    },
    validateSend() {
      let validate_new = true;

      Object.keys(this.errorSend).map((x, index) => {
        if (this.emailModal[x] == "") {
          this.errorSend[x] = this.arrayerrorSend[index];
          validate_new = false;
        }
      });

      if (validate_new != true) {
        this.validateTrans = false;
      } else {
        this.validateTrans = true;
      }
    },
    sendMail() {
      this.validateSend();
      if (this.validateTrans != false) {
        $("#sendLoaderMain").css("display", "none");
        $("#sendLoader").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Master/addMailContent.php`,
          data: JSON.stringify(this.emailModal),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            const { statusText, status, data } = result;

            if ( status == 200 && data) {
              $("#sendLoader").css("display", "none");
              $("#sendLoaderMain").css("display", "block");
              if ((data.msg = "Inserted Successfully")) {
                this.alert.content = "Added Successfully";

                this.$refs["addPop"].open();
              } else {
                this.alert.content = "Updated Successfully";

                this.$refs["addPop"].open();
              }
              this.getData();
              this.emailModal.event = "";
              this.emailModal.description = "";
            }
          })
          .catch(error => {});
      }
    },
    getData() {
      let vehicle_drive = {
        mail: "mail"
      };
      //  this.doLoading();

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/fetchMailsContent.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            if (data.contentDetails.length > 0) {
              this.emailBody = data.contentDetails;
            }
            $(".ql-toolbar").css("display", "block");
            $(".quill-editor").css("overflow", "visible");
            // this.JqueryFun();
          }
        })
        .catch(error => {});
    },
    JqueryFun() {
      return $(function() {
        $("#truckDetail2").DataTable();
      });
    }
  }
};
</script>
<style >
.md-direction-bottom-right {
  width: 22% !important;
}
.mrgtop-2per {
  margin-top: 2%;
}

.margTop-Booking {
  margin-top: 2%;
}
.mrgtop-5px {
  margin-top: 5px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 5px !important;
}
.md-button-color {
 background-color: #002b48 !important;
 transition: all 0.2ms;
  /* height: 10px; */
}

.md-button-color-toggle {
  background-color: #002b48 !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
.md-dialog-container {
  z-index: 999999 !important;
}
</style>


// WEBPACK FOOTER //
// addMailContent.vue?459dd256